import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  clearActivityDocumentDownload,
  getActivityDocumentDownload,
  getDetailQaActivity
} from "../../../../../redux/actions/AreaAction.jsx"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import {
  checkActivityIcon,
  checkActivityName,
  checkBadge,
  checkStatus,
  stringFormatting,
  convertDotToComma,
  convertM2ToHectare,
  toKilogram
} from "../../../../helpers/TextHelper.js"
import { ActivityDetailHeader } from "../../../../../component/molecule/ActivityDetailHeader/ActivityDetailHeader.jsx"
import { useTranslation } from "react-i18next"
import { Button, Card, Col, Row } from "react-bootstrap"
import { CardBody } from "../../../../../_metronic/_partials/controls/index.js"
import { RowText } from "../../../../../component/index.jsx"
import { timeStampToDate } from "../../../../helpers/DateHelper.js"
import {
  ACTIVITY_TYPE_ENUM,
  DATE_TYPE_ENUM,
  INSPECTION_STATUS_ENUM,
  INSPECTION_STATUS_STRING,
  ROUTING_STATUS,
  UNIT_STRING
} from "../../../../../constants/StringConstant.js"
import { Skeleton } from "@material-ui/lab"
import { CvlTable } from "../../../../../component/atoms/Tabel/CvlTable.jsx"
import { ImageWithModal } from "../../../../../component/atoms/ImageWithModal/index.jsx"
import { ModalMap } from "../../../../../component/atoms/ModalMap/index.jsx"
import { useHtmlClassService, useSubheader } from "../../../../../_metronic/layout/index.js"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { CloudDownloadOutlined } from "@material-ui/icons"
import { QAPhaseActivityDocument } from "../../../../../component/molecule/Print/QAPhaseActivityDocument.jsx"
import { ICON_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import SVG from "react-inlinesvg"
import { toast } from "react-toastify"

export const QaActivityDetail = ({
  match: {
    params: { status, id, activityId }
  }
}) => {
  const dispatch = useDispatch()
  const subHeader = useSubheader()
  const [data, setData] = useState({})
  const { Area, General } = useSelector((state) => state)
  const { t } = useTranslation()
  const [openMap, setOpenMap] = useState(false)
  const uiService = useHtmlClassService()

  useEffect(() => {
    dispatch(getDetailQaActivity(activityId))
    uiService.setExitFullPage()

    return () => {
      dispatch(clearActivityDocumentDownload())
    }
  }, [])

  useEffect(() => {
    subHeader.setBreadcrumbs([
      {
        pathname: RoutesConstants.AREA.LIST_BLOCK(ROUTING_STATUS.STATUS_ENUM.ACTIVE),
        title: t("label_area_name")
      },
      {
        pathname: RoutesConstants.AREA.LIST_BLOCK(ROUTING_STATUS.STATUS_STRING.ACTIVE),
        title: t("label_land_block")
      },
      {
        pathname: RoutesConstants.AREA.LIST_BLOCK(
          status === ROUTING_STATUS.STATUS_STRING.ACTIVE
            ? ROUTING_STATUS.STATUS_STRING.ACTIVE
            : status
        ),
        title:
          status === ROUTING_STATUS.STATUS_STRING.ACTIVE ? t("label_active") : t("label_history")
      },
      {
        pathname: RoutesConstants.AREA.DETAIL_BLOCK(status, id),
        title: stringFormatting(data?.block_code)
      },
      {
        title: t(checkActivityName(data?.activity_type_enum))
      }
    ])
    subHeader.setButton(
      <Button onClick={() => downloadDocument()}>
        <Row>
          <Col md={"auto"}>
            <CloudDownloadOutlined />
          </Col>
          <Col md={"auto"}>{t("label_document_download")}</Col>
        </Row>
      </Button>
    )
  }, [data])

  useEffect(() => {
    if (Area.activityDetail) {
      setData(Area.activityDetail)
    }
  }, [Area.activityDetail])

  useEffect(() => {
    const prevTitle = document.title
    if (Area?.activityDownload) {
      setTimeout(() => {
        document.title = `${data?.block_code}_${t(
          `${checkActivityName(data?.activity_type_enum)}`
        )}_${timeStampToDate(data?.activity_date, DATE_TYPE_ENUM.ISO_DATE_STRAP)}`
        window.print()
        setTimeout(() => {
          toast(t("messages_response_success_download_inspection_document"), {
            position: "top-center",
            autoClose: 5000,
            className: "bg-neutral-black",
            icon: <SVG src={ICON_CONSTANTS.BULLET_TICK} />,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "dark"
          })
          dispatch(clearActivityDocumentDownload())
        }, 1000)
      }, 5000)
    }
    return () => {
      document.title = prevTitle
    }
  }, [Area?.activityDownload])

  const downloadDocument = () => {
    dispatch(getActivityDocumentDownload(activityId))
  }

  const bottomContentHeader = () => {
    return (
      <div className={"w-auto mr-2"}>
        <Row>
          <Col className={"mr-4 border-right"} md={"auto"}>{`${t(
            "label_no_doc"
          )} : ${stringFormatting(data?.file_number)}`}</Col>
          <Col className={"mr-4 border-right"} md={"auto"}>{`${t(
            "label_no_file"
          )} : ${stringFormatting(data?.document_number)}`}</Col>
          <Col className={"mr-4"} md={"auto"}>{`${t("label_no_base")} : ${stringFormatting(
            data?.base_number
          )}`}</Col>
        </Row>
      </div>
    )
  }

  const bottomContent = (
    <Card className={"mt-6"} bg={"secondary"}>
      <CardBody className={"px-12 py-4"}>
        <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
          <RowText label={t("label_inspected_by")} value={stringFormatting(data?.inspection_by)} />
          <RowText
            label={t("label_inspection_date")}
            value={stringFormatting(
              timeStampToDate(data?.activity_date, DATE_TYPE_ENUM.ISO_DATETIME_STRAP)
            )}
          />
        </RowModule>
      </CardBody>
    </Card>
  )

  const activityDetail = (
    <ActivityDetailHeader
      icon={checkActivityIcon(data?.activity_type_enum)}
      title={t("messages_title_activity", {
        title: t(checkActivityName(data?.activity_type_enum))
      })}
      bottomContent={bottomContentHeader()}
      rightContent={checkStatus(data?.activity_status_enum)}
      cardBottom={bottomContent}
    />
  )

  const blockInformation = (
    <Card className={"mb-4"}>
      <CardBody>
        <h4 className={"mb-8 text-uppercase"}>
          {General.loading ? (
            <Skeleton animation="wave" variant={"text"} height={32} width={200} />
          ) : (
            t("label_block_land_info")
          )}
        </h4>
        <RowModule customColumnCss={"col-md-6 mb-2"} customSeparator={"my-0"}>
          <RowText label={t("label_block")} value={stringFormatting(data?.block_code)} />
          <RowText label={t("label_plant_type")} value={stringFormatting(data?.plant_type)} />
          <RowText
            label={t("label_mitra")}
            value={`${stringFormatting(data?.mitra_name)} (${stringFormatting(data?.mitra_phone)})`}
          />
          <RowText label={t("label_varietas")} value={stringFormatting(data?.variety)} />
          <RowText label={t("label_location")} value={stringFormatting(data?.location)} />
          <RowText label={t("label_seed_class")} value={stringFormatting(data?.seed_class)} />
        </RowModule>
        {(data?.activity_type_enum === ACTIVITY_TYPE_ENUM.FLOWERING ||
          data?.activity_type_enum === ACTIVITY_TYPE_ENUM.VEGETATIVE ||
          data?.activity_type_enum === ACTIVITY_TYPE_ENUM.RIPE) && (
          <Card className={"mt-6"} bg={"secondary"}>
            <CardBody className={"px-12 py-4"}>
              <h4 className={"mb-8 font-weight-bolder"} key={0}>
                {t("label_planting_realization")}
              </h4>
              <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
                <RowText
                  label={t("label_submission_land_area")}
                  value={
                    data?.planting_realization?.land_area_submit === null
                      ? "-"
                      : convertDotToComma(
                          convertM2ToHectare(data?.planting_realization?.land_area_submit, 4),
                          UNIT_STRING.HA
                        )
                  }
                />
              </RowModule>
            </CardBody>
          </Card>
        )}
      </CardBody>
    </Card>
  )

  const isolationInfo = (
    <Card className={"mb-4"}>
      <CardBody>
        <h4 className={"mb-8 text-uppercase"}>
          {General.loading ? (
            <Skeleton animation="wave" variant={"text"} height={32} width={200} />
          ) : (
            t("label_isolation_plant")
          )}
        </h4>
        <Card className={"mt-6"} bg={"secondary"}>
          <CardBody className={"px-12 py-4"}>
            <h4 className={"mb-10 font-weight-bolder"} key={0}>
              {t("label_north_side")}
            </h4>
            <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
              <RowText
                label={t("label_isolation_status")}
                value={stringFormatting(
                  data?.isolation?.north_status ? t("label_eligible") : t("label_non_eligible")
                )}
              />
              <RowText
                label={t("label_plant_information_around")}
                value={stringFormatting(data?.isolation?.north_plant)}
              />
            </RowModule>
          </CardBody>
        </Card>
        <Card className={"mt-6"} bg={"secondary"}>
          <CardBody className={"px-12 py-4"}>
            <h4 className={"mb-10 font-weight-bolder"} key={1}>
              {t("label_east_side")}
            </h4>
            <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
              <RowText
                label={t("label_isolation_status")}
                value={stringFormatting(
                  data?.isolation?.east_status ? t("label_eligible") : t("label_non_eligible")
                )}
              />
              <RowText
                label={t("label_plant_information_around")}
                value={stringFormatting(data?.isolation?.east_plant)}
              />
            </RowModule>
          </CardBody>
        </Card>
        <Card className={"mt-6"} bg={"secondary"}>
          <CardBody className={"px-12 py-4"}>
            <h4 className={"mb-10 font-weight-bolder"} key={2}>
              {t("label_south_side")}
            </h4>
            <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
              <RowText
                label={t("label_isolation_status")}
                value={stringFormatting(
                  data?.isolation?.south_status ? t("label_eligible") : t("label_non_eligible")
                )}
              />
              <RowText
                label={t("label_plant_information_around")}
                value={stringFormatting(data?.isolation?.south_plant)}
              />
            </RowModule>
          </CardBody>
        </Card>
        <Card className={"mt-6"} bg={"secondary"}>
          <CardBody className={"px-12 py-4"}>
            <h4 className={"mb-10 font-weight-bolder"} key={3}>
              {t("label_west_side")}
            </h4>
            <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
              <RowText
                label={t("label_isolation_status")}
                value={stringFormatting(
                  data?.isolation?.west_status ? t("label_eligible") : t("label_non_eligible")
                )}
              />
              <RowText
                label={t("label_plant_information_around")}
                value={stringFormatting(data?.isolation?.west_plant)}
              />
            </RowModule>
          </CardBody>
        </Card>
      </CardBody>
    </Card>
  )

  const inspectionResult = (
    <Card className={"mb-4"}>
      <CardBody>
        <h4 className={"mb-8 text-uppercase"}>
          {General.loading ? (
            <Skeleton animation="wave" variant={"text"} height={32} width={200} />
          ) : (
            t("label_inspection_result")
          )}
        </h4>
        {
          // PRELIMINARY
          data?.activity_type_enum === ACTIVITY_TYPE_ENUM.PRELIMINARY && (
            <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
              <RowText
                label={t("label_correctness_location")}
                value={
                  data?.result?.area_location_validation === null
                    ? "-"
                    : data?.result?.area_location_validation
                    ? t("label_correct")
                    : t("label_incorrect")
                }
              />
              <RowText
                label={t("label_correctness_land_area")}
                value={
                  data?.result?.area_land_validation === null
                    ? "-"
                    : data?.result?.area_land_validation
                    ? t("label_correct")
                    : t("label_incorrect")
                }
              />
              <RowText
                label={t("label_correctness_seed")}
                value={
                  data?.result?.seed_source_used === null
                    ? "-"
                    : data?.result?.seed_source_used
                    ? t("label_correct")
                    : t("label_incorrect")
                }
              />
              <RowText
                label={t("label_correctness_history")}
                value={
                  data?.result?.land_history === null
                    ? "-"
                    : data?.result?.land_history
                    ? t("label_correct")
                    : t("label_incorrect")
                }
              />
            </RowModule>
          )
        }
        {
          // VEGETATIVE, FLOWERING, RIPE
          (data?.activity_type_enum === ACTIVITY_TYPE_ENUM.VEGETATIVE ||
            data?.activity_type_enum === ACTIVITY_TYPE_ENUM.FLOWERING ||
            data?.activity_type_enum === ACTIVITY_TYPE_ENUM.RIPE) && (
            <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
              <RowText
                label={t("label_plant_trait_variety")}
                value={
                  data?.result?.plant_characteristic === null
                    ? "-"
                    : data?.result?.plant_characteristic
                    ? t("label_correct")
                    : t("label_incorrect")
                }
              />
              <RowText
                label={t("label_harvest_date_estimation")}
                value={stringFormatting(
                  timeStampToDate(
                    data?.result?.estimate_harvest_date,
                    DATE_TYPE_ENUM.ISO_DATE_STRAP
                  )
                )}
              />
              <RowText
                label={t("label_pest_disease_condition")}
                value={stringFormatting(data?.result?.pest_condition)}
              />
              <RowText
                label={t("label_seed_production_estimation")}
                value={
                  data?.result?.estimate_seed_production
                    ? toKilogram(data?.result?.estimate_seed_production)
                    : "-"
                }
              />
              <RowText
                label={t("label_grass_condition")}
                value={stringFormatting(data?.result?.grass_condition)}
              />
            </RowModule>
          )
        }
        {
          // HARVEST
          data?.activity_type_enum === ACTIVITY_TYPE_ENUM.HARVEST && (
            <>
              <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
                <RowText
                  label={t("label_harvest_start_date")}
                  value={timeStampToDate(
                    data?.result?.harvest_start_date,
                    DATE_TYPE_ENUM.ISO_DATE_ID
                  )}
                />
                <RowText
                  label={t("label_harvest_duration")}
                  value={stringFormatting(data?.result?.harvest_day, "hari")}
                />
                <RowText
                  label={t("label_harvest_end_date")}
                  value={timeStampToDate(
                    data?.result?.harvest_end_date,
                    DATE_TYPE_ENUM.ISO_DATE_ID
                  )}
                />
                <RowText
                  label={t("label_harvest_weather")}
                  value={stringFormatting(data?.result?.weather_condition)}
                />
                <RowText
                  label={t("label_age_at_harvest")}
                  value={stringFormatting(data?.result?.hst, "HST")}
                />
              </RowModule>
              <Card className={"mt-6"} bg={"secondary"}>
                <CardBody className={"px-12 py-4"}>
                  <h4 className={"mb-10 font-weight-bolder"} key={3}>
                    {t("label_harvest_tools")}
                  </h4>
                  <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
                    <RowText
                      label={t("label_tool_harvest_machine")}
                      value={
                        data?.result?.harvest_tool === null
                          ? "-"
                          : data?.result?.harvest_tool
                          ? t("label_eligible")
                          : t("label_non_eligible")
                      }
                    />
                    <RowText
                      label={t("label_container_sack")}
                      value={
                        data?.result?.sack === null
                          ? "-"
                          : data?.result?.sack
                          ? t("label_eligible")
                          : t("label_non_eligible")
                      }
                    />
                    <RowText
                      label={t("label_power_thresher")}
                      value={
                        data?.result?.power_thresher === null
                          ? "-"
                          : data?.result?.power_thresher
                          ? t("label_eligible")
                          : t("label_non_eligible")
                      }
                    />
                    <RowText
                      label={t("label_weight_scales")}
                      value={
                        data?.result?.weight === null
                          ? "-"
                          : data?.result?.weight
                          ? t("label_eligible")
                          : t("label_non_eligible")
                      }
                    />
                  </RowModule>
                </CardBody>
              </Card>
            </>
          )
        }
      </CardBody>
    </Card>
  )

  const modalMap = (
    <ModalMap
      open={openMap}
      setOpenMap={setOpenMap}
      areas={data?.summary?.area_list}
      centroid={data?.summary?.block_centroid}
      hideDate={true}
      parse={true}
      withStatus={true}
    />
  )

  const inspectionAreaStatus = (
    <Card className={"mb-4"}>
      <CardBody>
        <h4 className={"mb-8 text-uppercase"}>
          {General.loading ? (
            <Skeleton animation="wave" variant={"text"} height={32} width={200} />
          ) : (
            t("label_inspection_area_status")
          )}
        </h4>
        <Card className={"mt-4 mb-6 p-2"} bg={"secondary"}>
          <CardBody className={"p-4 d-flex align-content-between"}>
            <div className={"d-flex w-full"}>
              <div className={"mr-2"}>{`${t("label_total_land_pass")}:`}</div>
              <div className={"font-size-lg font-weight-bolder mr-1"}>
                {data?.summary?.land_area_passed === null
                  ? "-"
                  : convertDotToComma(convertM2ToHectare(data?.summary?.land_area_passed, 4), UNIT_STRING.HA)}
              </div>
            </div>
            <a
              className={"w-full d-flex justify-content-end mr-2 link"}
              onClick={() => setOpenMap(true)}>
              {t("label_see_map_area")}
            </a>
          </CardBody>
        </Card>
        <h6 className={"mb-8 capitalize"}>
          {General.loading ? (
            <Skeleton animation="wave" variant={"text"} height={24} width={200} />
          ) : (
            t("label_list_area")
          )}
        </h6>
        {data?.summary?.area_list.map((item, index) => {
          return (
            <Card key={index} className={"mb-4"} bg={"secondary"}>
              <CardBody>
                <div className={"d-flex align-items-center mb-4"}>
                  <h6 className={"m-0 mr-2"}>{item.name}</h6>
                  {checkBadge(item.area_status_enum, "h-6 py-1 px-2 w-fit")}
                </div>
                <RowModule customColumnCss={"col-md-6"} customSeparator={"my-0"}>
                  <RowText
                    label={t("label_pass_area")}
                    value={
                      item.total_area_pass === null
                        ? "-"
                        : convertDotToComma(convertM2ToHectare(item.total_area_pass, 4), UNIT_STRING.HA)
                    }
                  />
                  <RowText
                    label={t("label_not_pass_area")}
                    value={
                      item.total_area_not_pass === null
                        ? "-"
                        : convertDotToComma(convertM2ToHectare(item.total_area_not_pass, 4), UNIT_STRING.HA)
                    }
                  />
                </RowModule>
                {item.area_status_enum === INSPECTION_STATUS_ENUM.PARTIAL_PASS && (
                  <RowModule>
                    <RowText
                      label={t("label_not_pass_location")}
                      value={stringFormatting(item.area_not_pass_location)}
                    />
                    <RowText
                      label={t("label_count_male_not_pass")}
                      value={stringFormatting(item.male_row_not_pass, "Baris")}
                    />
                  </RowModule>
                )}
                {item.area_status_enum === INSPECTION_STATUS_ENUM.PARTIAL_PASS ||
                item.area_status_enum === INSPECTION_STATUS_ENUM.NOT_PASS ? (
                  <>
                    <div className="separator separator-solid my-4" />
                    <RowText label={t("label_reason")} value={stringFormatting(item.reason)} />
                  </>
                ) : (
                  <></>
                )}
              </CardBody>
            </Card>
          )
        })}
      </CardBody>
    </Card>
  )

  const cvlTable = (
    <Card className={"mb-4"}>
      <CardBody>
        <h4 className={"mb-8 capitalize"}>
          {General.loading ? (
            <Skeleton animation="wave" variant={"text"} height={24} width={200} />
          ) : (
            t("label_cvl_type_hybrid")
          )}
        </h4>
        <div>
          <h6 className={"mb-4"}>
            {General.loading ? (
              <Skeleton animation="wave" variant={"text"} height={24} width={200} />
            ) : (
              t("label_female")
            )}
          </h6>
          <CvlTable data={data?.cvl?.female} />
        </div>
        {(data?.activity_type_enum === ACTIVITY_TYPE_ENUM.VEGETATIVE ||
          data?.activity_type_enum === ACTIVITY_TYPE_ENUM.FLOWERING) && (
          <div>
            <h6 className={"mb-4"}>
              {General.loading ? (
                <Skeleton animation="wave" variant={"text"} height={24} width={200} />
              ) : (
                t("label_male")
              )}
            </h6>
            <CvlTable data={data?.cvl?.male} />
          </div>
        )}
        {data?.activity_type_enum === ACTIVITY_TYPE_ENUM.FLOWERING && (
          <div>
            <h6 className={"mb-4"}>
              {General.loading ? (
                <Skeleton animation="wave" variant={"text"} height={24} width={200} />
              ) : (
                t("flower_left_female")
              )}
            </h6>
            <CvlTable data={data?.cvl?.male_on_female} />
          </div>
        )}
        {data?.activity_type_enum === ACTIVITY_TYPE_ENUM.RIPE && (
          <div>
            <h6 className={"mb-4"}>
              {General.loading ? (
                <Skeleton animation="wave" variant={"text"} height={24} width={200} />
              ) : (
                t("label_male_parent_stay")
              )}
            </h6>
            <CvlTable data={data?.cvl?.male_flower_left} />
          </div>
        )}
      </CardBody>
    </Card>
  )

  const conclusion = (
    <Card className={"mb-4"}>
      <CardBody>
        <h4 className={"mb-8 text-uppercase"}>
          {General.loading ? (
            <Skeleton animation="wave" variant={"text"} height={32} width={200} />
          ) : (
            t("label_conclusion")
          )}
        </h4>
        {data?.activity_type_enum === ACTIVITY_TYPE_ENUM.PRELIMINARY && (
          <>
            {data?.activity_status_enum !== INSPECTION_STATUS_ENUM.NOT_PASS && (
              <RowModule>
                <RowText
                  label={t("label_total_land_pass")}
                  value={convertDotToComma(
                    convertM2ToHectare(data?.summary?.land_area_passed, 4),
                    UNIT_STRING.HA
                  )}
                />
              </RowModule>
            )}
            <RowModule>
              <RowText label={t("label_note")} value={stringFormatting(data?.summary?.note)} />
            </RowModule>
          </>
        )}
        {(data?.activity_type_enum === ACTIVITY_TYPE_ENUM.FLOWERING ||
          data?.activity_type_enum === ACTIVITY_TYPE_ENUM.VEGETATIVE ||
          data?.activity_type_enum === ACTIVITY_TYPE_ENUM.RIPE) && (
          <RowModule>
            <RowText
              label={t("label_block_condition")}
              value={INSPECTION_STATUS_STRING[data?.activity_status_enum]}
            />
          </RowModule>
        )}
        {data?.activity_type_enum === ACTIVITY_TYPE_ENUM.HARVEST && (
          <RowModule>
            <RowText
              label={t("label_dry_seed_total_harvest")}
              value={data?.potential_seeds ? toKilogram(data?.potential_seeds, false) : "-"}
            />
          </RowModule>
        )}
      </CardBody>
    </Card>
  )

  const documentationActivity = (
    <Card>
      <CardBody>
        <h4 className={"mb-6 text-uppercase"}>
          {General.loading ? (
            <Skeleton animation="wave" variant={"text"} height={32} width={200} />
          ) : (
            t("label_activity_documentation")
          )}
        </h4>

        <RowModule customColumnCss={"col-md-1 mb-2"}>
          {data?.images?.length > 0
            ? data?.images?.map((item, index) => {
                return (
                  <ImageWithModal
                    key={index}
                    value={item}
                    className={""}
                    titleModal={t("label_location_image")}
                    imageType={"rectangle"}
                  />
                )
              })
            : "-"}
        </RowModule>
      </CardBody>
    </Card>
  )

  return (
    <>
      {Area?.activityDownload !== null && <QAPhaseActivityDocument data={Area?.activityDownload} />}
      <div className={"d-print-none"}>
        {openMap && modalMap}
        {activityDetail}
        {blockInformation}
        {(data?.activity_type_enum === ACTIVITY_TYPE_ENUM.FLOWERING ||
          data?.activity_type_enum === ACTIVITY_TYPE_ENUM.VEGETATIVE ||
          data?.activity_type_enum === ACTIVITY_TYPE_ENUM.RIPE ||
          data?.activity_type_enum === ACTIVITY_TYPE_ENUM.PRELIMINARY) &&
          isolationInfo}
        {inspectionResult}
        {(data?.activity_type_enum === ACTIVITY_TYPE_ENUM.FLOWERING ||
          data?.activity_type_enum === ACTIVITY_TYPE_ENUM.VEGETATIVE ||
          data?.activity_type_enum === ACTIVITY_TYPE_ENUM.RIPE ||
          data?.activity_type_enum === ACTIVITY_TYPE_ENUM.HARVEST) &&
          inspectionAreaStatus}
        {(data?.activity_type_enum === ACTIVITY_TYPE_ENUM.FLOWERING ||
          data?.activity_type_enum === ACTIVITY_TYPE_ENUM.VEGETATIVE ||
          data?.activity_type_enum === ACTIVITY_TYPE_ENUM.RIPE) &&
          cvlTable}
        {conclusion}
        {documentationActivity}
      </div>
    </>
  )
}